import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogDetailModule } from '../change-log-detail/change-log-detail.module';
import { PersonalInfoLogDetailsComponent } from '../personal-info-log-details/personal-info-log-details.component';
import { ChangeLogPipesModule } from '../../pipes/change-log-pipes.module';
import { ChangeLogDetailByTypeModule } from '../change-log-detail-by-type/change-log-detail-by-type.module';

@NgModule({
  declarations: [PersonalInfoLogDetailsComponent],
  imports: [CommonModule, SharedModule, ChangeLogDetailModule, ChangeLogPipesModule, ChangeLogDetailByTypeModule],
  exports: [PersonalInfoLogDetailsComponent],
})
export class PersonalInfoLogDetailsModule {}
